import { Box, VStack, Heading, Text } from "@chakra-ui/react";
import { useGetPayByIdQuery } from "apis";
import { PaymentSuccessIllustrationSVG } from "assets";
import { CloseWindow, Link } from "components";
import { ViewProps } from "pages/BuyAndSell/Payment";
import { useEffect, useState } from "react";

export function PaySuccessView(props: ViewProps) {
  const { id } = props;
  const { data } = useGetPayByIdQuery(id!);

  const [payStatus, setPayStatus] = useState({
    title: "Processing",
    description: "Your payment was successful! We will process your transaction shortly",
  });

  useEffect(() => {
    if (data?.paymentStatus! === "timedout" || data?.paymentStatus! === "cancelled") {
      setPayStatus({
        description: "",
        title: "Payment Failed",
      });
    }

    if (data?.paymentStatus === "confirmed") {
      setPayStatus({
        description: "We received your payment",
        title: "Payment Confirmed",
      });
    }

    if (data?.paymentStatus === "paid") {
      setPayStatus({
        description: "Transfer successfully sent",
        title: "Pay Successful",
      });
    }
  }, [data]);

  return (
    <Box>
      <Box maxW="720px" m="0 auto" pos="relative">
        <Box minH="70vh">
          <VStack color="white" my="40px" bg="primary.default" borderRadius="10px" p="20px">
            <Box borderRadius="50%" bg="#E8C229" boxSize="104px" display="flex" justifyContent="center" alignItems="center">
              <Box as={PaymentSuccessIllustrationSVG} />
            </Box>

            <Heading my="30px !important" as="h4" fontSize="32px">
              {payStatus.title}!
            </Heading>
            <Text fontWeight="500" textAlign="center">
              {payStatus.description}
            </Text>
          </VStack>

          <VStack my="40px !important">
            <Text fontSize="md" fontWeight="600">
              Transaction Id
            </Text>

            <Link to={`/pay/${id}`} textDecoration="underline" color="secondary.default" fontWeight="500">
              {id}
            </Link>

            <CloseWindow />
          </VStack>
        </Box>
      </Box>
    </Box>
  );
}
